import request from './index';

export function getInfo() {
  return request({
    url: 'kr/login/info',
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    }
  })
}

export function userRegister(userData) {
  return request({
    url: 'kr/login/join',
    method: 'post',
    data: userData
  });
}

export function login(userData) {
  return request({
    url: 'kr/login/login',
    method: 'post',
    data: userData
  });
}

export function checkID(user_id) {
  return request({
    url: 'kr/login/check-id',
    method: 'get',
    params: { user_id } // ✅ 여기 중요!
  });
}

export function googleLogin(token) {
  return request({
    url: 'kr/login/google',
    method: 'post',
    data: { token } // token을 백엔드에 넘김
  });
}

export function checkAttentionStock(user_id, ticker) {
  return request({
    url: 'kr/login/attention',
    method: 'get',
    params: { user_id, ticker }
  });
}

export function addAttentionStock(user_id, ticker, stk_typ, ctr_typ) {
  return request({
    url: 'kr/login/add',
    method: 'post',
    data: { user_id, ticker, stk_typ, ctr_typ }
  });
}

export function removeAttentionStock(user_id, ticker) {
  return request({
    url: 'kr/login/delete',
    method: 'delete',
    data: { user_id, ticker }
  });
}

export function getAttentionList() {
  return request({
    url: 'kr/login/attention-list',
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`
    }
  });
}
// note: getInfo already defined above; no mock re-export
